import React, { ReactNode } from 'react'
import { alpha, IconButton, Toolbar, useTheme } from '@mui/material'
import { designTokens } from '@/theme'
import { Heading } from '@/components/texts/heading'
import { ArrowLeftIcon } from '@/components/icons'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTenantBranding } from '@/hooks/use-tenant-branding'

const Titlebar = ({ title, backIcon, onGoBack, secondaChild }: { title: string, backIcon?: boolean, onGoBack?: () => void, secondaChild?: ReactNode }) => {

    const theme = useTheme()
    const { themeColor, isCustomTheme } = useTenantBranding()
    const navigate = useNavigate()
    const location = useLocation()

    const fromLocation = location?.state?.fromLocation
    const fromPath = fromLocation?.pathname || '/'

    const onBack = () => onGoBack ? onGoBack() : navigate(fromPath, { state: fromLocation?.state, replace: true })

    return (
        <Toolbar
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: theme.zIndex.appBar,
                background: alpha(theme.palette.background.default, 0.5),
                backdropFilter: 'blur(10px)',
                pl: backIcon ? 0 : 2,
                pr: 2,
                transition: `background ${designTokens.motion.slow}`,
                mb: 1,
                gap: 1,
            }}
        >
            {backIcon &&
                <IconButton onClick={onBack}><ArrowLeftIcon /></IconButton>
            }
            <Heading
                data-testid="screen-title"
                data-tenant-theme={isCustomTheme ? themeColor : undefined}
                sx={{
                    color: isCustomTheme ? themeColor : theme.palette.primary.main,
                    flex: 1,
                }}
            >
                {title}
            </Heading>

            {secondaChild}
        </Toolbar>
    )
}

export default Titlebar
